import { axios } from './client';
import { setupCommonInterceptors } from './client/interceptors';

/**
 * Function that runs *once* when the app is starting.
 */
export function initApp() {
  setupCommonInterceptors(axios);
}
